<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import { mapState } from "vuex";
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "BIContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	computed: {
		...mapState(["usuario"]),
	},
	methods: {
		montarMenu() {
			let m = [];

      if (this.permissao("price_bi")) {
        m.push({
          titulo: "Pricing BI",
          titulo_app: "BI",
          icon: "mdi-sync",
          to: "/pricing",
          tooltip: "Acesso ao BI",
        });
      }

      if (this.permissao("estoque_bi")) {
        m.push({
          titulo: "ESTOQUE BI",
          titulo_app: "BI",
          to: "/central_bi/estoquebi",
          icon: "mdi-file-table-box-outline",
          tooltip: "Acesso ao BI de Estoque",
        });
      }

      if (this.permissao("giro_bi")) {
        m.push({
          titulo: "GIRO E COBERTURA BI",
          titulo_app: "BI",
          to: "/central_bi/girobi",
          icon: "mdi-cached",
          tooltip: "Acesso ao BI de Giro e Cobertura",
        });
      }
      if (this.permissao("vendas_bi")) {
        m.push({
          titulo: "VENDAS BI",
          titulo_app: "BI",
          to: "/central_bi/vendasbi",
          icon: "mdi-sale-outline",
          tooltip: "Acesso ao BI de Vendas",
        });
      }
      if (this.permissao("ajusteestoque_bi")) {
        m.push({
          titulo: "AJUSTE ESTOQUE BI",
          titulo_app: "BI",
          to: "/central_bi/ajusteestoquebi",
          icon: "mdi-archive-alert",
          tooltip: "Acesso ao BI de Ajuste de Estoque",
        });
      }
      if (this.permissao("divergencias_bi")) {
        m.push({
          titulo: "EST. VIRTUAL X DIVERGÊNCIAS BI",
          titulo_app: "BI",
          to: "/central_bi/divergenciasbi",
          icon: "mdi-comment-alert",
          tooltip: "Acesso ao BI de Estoque Virtual X Divergências",
        });
      }
      if (this.permissao("vendas_vendedor_bi")) {
        m.push({
          titulo: "RANKING VENDEDORES BI",
          titulo_app: "BI",
          to: "/central_bi/vendas_vendedor_bi",
          icon: "mdi-sale-outline",
          tooltip: "Acesso ao BI de Vendas de Vendedores",
        });
      }

      if (this.permissao("analise_x_abastecimento_bi")) {
        m.push({
          titulo: "Pedidos vs Abastecimento BI",
          titulo_app: "BI",
          icon: "mdi-warehouse",
          to: "/central_bi/analisetvabastecimento",
          tooltip: "Análise de Pedidos vs Abastecimento BI",
        });
      }

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>